export default __webpack_public_path__ + "static/MS_startups_logo-5d80de3001f7dcb60cf6cf5b97b04c13.png";